<template>
    <div class="my-set-sub-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar class="my-set-ui-title-bar" v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>
        <!-- 3. 说明部分 -->
        <my-set-form></my-set-form>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import MySetForm from '../../layouts/my/MySetForm.vue'
import { MIX } from '../../modules/utils'
export default {
    name: 'MySetUI',
    components: { TitleBar, MySetForm },
    computed: {
        detailInfo() {
            return this.$store.state.detail.personInfo
        },
    },
    data() {
        return {
            titleData: {'titleText': '命盘设置', 'showCancel': false},
            telNumValue: '',
            codeValue: '',
            verifyLocked: true,
            canClick: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth+'px';
            this.$el.style.height = innerHeight+'px';
            MIX.trackPageViewed('MingPanUISetting');
        },
        initData() {
            this.$store.dispatch('setting/initSettingUIData', {
                detailInfo: this.detailInfo
            })
        },
        clickBack() {
            var curpath = this.$router.history.current.path;
            if(curpath.indexOf('detail') != -1) {
                this.$store.dispatch('detail/fatefortune/checkDetailFortuneData')
            }
            this.$router.go(-1);
        },
    }
}
</script>